import { render } from "./HeaderNotificationsNotifyApproved.vue?vue&type=template&id=b2f4e120&scoped=true"
import script from "./HeaderNotificationsNotifyApproved.vue?vue&type=script&lang=js"
export * from "./HeaderNotificationsNotifyApproved.vue?vue&type=script&lang=js"

import "./HeaderNotificationsNotifyApproved.vue?vue&type=style&index=0&id=b2f4e120&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f4e120"]])

export default __exports__